import type { ReactNode } from "react";
import { Card } from "./Card";

/**
 * The row of things a list is narrowed by, with the screen's own button at the end of it.
 *
 * <p>The button sits with the filters rather than above them because it belongs to the same
 * strip of controls: everything that acts on the list is then in one place, on one line, instead
 * of the action being marooned in a heading block of its own.
 *
 * <p>It is pushed to the far end rather than following the last filter. Filters vary in number
 * from screen to screen, and a button that lands in a different place on each one is a button
 * people have to look for.
 */
export function FilterBar({
  children,
  actions,
}: {
  children: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <Card className="mb-4">
      <div className="flex flex-wrap items-end gap-4 p-4">
        {children}
        {actions && <div className="ml-auto flex items-center gap-2">{actions}</div>}
      </div>
    </Card>
  );
}
